import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const getPlaylistName = (index, totalCount) => {
  if (totalCount === 1) return "Main Playlist";
  if (index === 0) return "Playlist 1";
  if (index === 1) return "Playlist 2";
  return `Additional Playlist ${index - 1}`;
};

const PlaylistPlaceholder = ({ index, totalCount, onClick, playlist }) => {
  return (
    <Paper
      elevation={0}
      onClick={onClick}
      sx={{
        width: "100%",
        height: "400px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        backgroundColor: "#f0e6ff",
        borderRadius: "8px",
        transition: "background-color 0.2s",
        "&:hover": {
          backgroundColor: "#e6d9ff",
        },
      }}
    >
      {playlist ? (
        <Box sx={{ p: 4, width: "100%", height: "100%" }}>
          <Typography variant="h5" color="#4b445b" gutterBottom>
            {getPlaylistName(index, totalCount)}
          </Typography>
          <Typography
            variant="body1"
            color="#4b445b"
            sx={{ mt: 2, opacity: 0.8 }}
          >
            {`${playlist?.playlist?.length || 0} songs`}
          </Typography>
          <Typography
            variant="body1"
            color="#4b445b"
            sx={{ mt: 1, opacity: 0.8 }}
          >
            {playlist?.startTime && playlist?.endTime ? (
              <>
                {new Date(playlist.startTime).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
                {" - "}
                {new Date(playlist.endTime).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </>
            ) : null}
          </Typography>
        </Box>
      ) : (
        <>
          <AddIcon
            sx={{ fontSize: 60, color: "#4b445b", mb: 2, opacity: 0.8 }}
          />
          <Typography variant="h5" color="#4b445b" sx={{ opacity: 0.8 }}>
            {getPlaylistName(index, totalCount)}
          </Typography>
        </>
      )}
    </Paper>
  );
};

export default PlaylistPlaceholder;
